import { Box, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import React from 'react';

import { SecuritiesTransferDetailItemNormalized } from '../../../../store/customerDetail/SecuritiesTransfer/types';
import {
  SourceAndDestination,
  SourceAndDestinationLoading,
} from '../../../CustomerDetail/components/SecuritiesTransfer/components/TableTransferRequests/TransferRequestsItem/components/SourceAndDestination';

import { BasicInfos, BasicInfosLoading } from './BasicInfos';
import { GrossValue } from './GrossValue';
import { MobileInfos, MobileInfosLoading } from './MobileInfos';

interface MainInfoContainerDefaultProps {
  isMobile: boolean;
  isTablet: boolean;
}

export interface MainInfoContainerProps extends MainInfoContainerDefaultProps {
  securitiesTransferItem: SecuritiesTransferDetailItemNormalized;
  hasSelfOrigin: boolean;
}

export const MainInfoContainer: React.FC<MainInfoContainerProps> = ({
  securitiesTransferItem,
  hasSelfOrigin,
  isTablet,
  isMobile,
}) => {
  if (isMobile) {
    return (
      <VStack
        background={isMobile ? 'neutral.white' : 'transparent'}
        space="stack.xxxs"
        borderColor="neutral.lightest"
        borderWidth="1"
        borderStyle="solid"
        borderRadius={BoxBorder.heavy}
        px="inline.xxxs"
        py="stack.xxs">
        <SourceAndDestination w="full" {...securitiesTransferItem} />
        <MobileInfos
          infos={[
            ...(hasSelfOrigin
              ? [{ label: 'Valor bruto', value: securitiesTransferItem.grossValueNormalized }]
              : []),
            { label: 'Transferência', value: securitiesTransferItem.solicitationTypeNormalized },
            { label: 'Solicitado via', value: securitiesTransferItem.requestedByWayOfNormalized },
            { label: 'Solicitado em', value: securitiesTransferItem.requestDateTimeNormalized },
            { label: 'Protocolo', value: securitiesTransferItem.protocolNormalized },
          ]}
        />
      </VStack>
    );
  }

  if (hasSelfOrigin || isTablet) {
    return (
      <VStack
        borderColor="neutral.lightest"
        borderWidth="1"
        borderStyle="solid"
        px="inline.xxs"
        py="stack.xxxs"
        borderRadius={BoxBorder.heavy}>
        <HStack>
          <SourceAndDestination w={isTablet ? 'full' : undefined} {...securitiesTransferItem} />

          {!!hasSelfOrigin && (
            <Stack>
              <Box
                h="full"
                borderRightWidth="1"
                borderRightColor="neutral.light"
                borderStyle="dashed"
                mx="inline.xxs"
              />
            </Stack>
          )}

          {!!hasSelfOrigin && <GrossValue {...securitiesTransferItem} />}
        </HStack>

        <Box
          w="full"
          borderTopWidth="1"
          borderTopColor="neutral.lightest"
          borderStyle="solid"
          my="inline.xxxs"
        />

        <BasicInfos {...securitiesTransferItem} />
      </VStack>
    );
  }

  return (
    <HStack
      alignItems="center"
      justifyContent="space-between"
      borderColor="neutral.lightest"
      borderWidth="1"
      borderStyle="solid"
      px="inline.xxs"
      py="stack.xxxs"
      borderRadius={BoxBorder.heavy}>
      <SourceAndDestination {...securitiesTransferItem} />

      <Box
        h="full"
        borderRightWidth="1"
        borderRightColor="neutral.light"
        borderStyle="dashed"
        mx="inline.xxs"
      />

      <BasicInfos {...securitiesTransferItem} />
    </HStack>
  );
};

export const MainInfoContainerLoading: React.FC<MainInfoContainerDefaultProps> = ({
  isTablet,
  isMobile,
}) => {
  if (isMobile) {
    return (
      <VStack
        background={isMobile ? 'neutral.white' : 'transparent'}
        space="stack.xxxs"
        borderColor="neutral.lightest"
        borderWidth="1"
        borderStyle="solid"
        borderRadius={BoxBorder.heavy}
        px="inline.xxxs"
        py="stack.xxs">
        <SourceAndDestinationLoading w="full" />
        <MobileInfosLoading
          infos={[
            { label: 'Transferência' },
            { label: 'Solicitado via' },
            { label: 'Solicitado em' },
            { label: 'Protocolo' },
          ]}
        />
      </VStack>
    );
  }

  if (isTablet) {
    return (
      <VStack
        borderColor="neutral.lightest"
        borderWidth="1"
        borderStyle="solid"
        px="inline.xxs"
        py="stack.xxxs"
        borderRadius={BoxBorder.heavy}>
        <SourceAndDestinationLoading w={isTablet ? 'full' : undefined} />

        <Box
          w="full"
          borderTopWidth="1"
          borderTopColor="neutral.lightest"
          borderStyle="solid"
          my="inline.xxxs"
        />

        <BasicInfosLoading />
      </VStack>
    );
  }

  return (
    <HStack
      alignItems="center"
      justifyContent="space-between"
      borderColor="neutral.lightest"
      borderWidth="1"
      borderStyle="solid"
      px="inline.xxs"
      py="stack.xxxs"
      borderRadius={BoxBorder.heavy}>
      <SourceAndDestinationLoading />

      <Box
        h="full"
        borderRightWidth="1"
        borderRightColor="neutral.light"
        borderStyle="dashed"
        mx="inline.xxs"
      />

      <BasicInfosLoading />
    </HStack>
  );
};
